/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsProfileCtrl
 */
angular.module('mercury.modules.settings.profile')
.controller('SettingsProfileCtrl', ["authService", "ngToast", "$resource", "$scope", "settings", "title", "userinfo", function(authService, ngToast, $resource, $scope, settings, title, userinfo) {
  title.set('My Profile');

  var baseUrl = settings.mercHost + '/user-session';

  var User = $resource(baseUrl, {}, {
    updateProfile: {url: baseUrl + '/profile', method: 'PUT'},
    updateEmail: {url: baseUrl + '/email', method: 'PUT'},
    changePassword: {url: baseUrl + '/password', method: 'PUT'}
  });

  $scope.setPasswordRequestModel = {password: '', confirmPassword: ''};
  $scope.updatePasswordRequestModel = {password: '', confirmPassword: ''};
  $scope.changePasswordRequestModel = {email: '', password: ''};

  var userDetails = userinfo.userDetails();

  $scope.user = {
    name: userDetails.firstName,
    lastName: userDetails.lastName,
    userName: userDetails.email,
    logins: userDetails.logins,
    hasPassword: userDetails.hasPassword
  };

  $scope.updateUser = function() {
    var updateProfile = User.updateProfile($scope.user);
    $scope.updatingProfile = updateProfile.$promise;
    updateProfile.$promise.then(
      function() {
        userinfo.setUserDetails({
          name: $scope.user.name + ' ' + $scope.user.lastName,
          firstName: $scope.user.name,
          lastName: $scope.user.lastName
        });
        ngToast.success({
          content: 'Profile Updated'
        });
        $scope.profileErrorState = null;
      },
      function(response) {
        $scope.profileErrorState = response.data.errors;
      }
    );
  };

  $scope.updateEmail = function() {
    $scope.changeEmailRequestModel.email = $scope.user.userName;
    var updatingEmail = User.updateEmail($scope.changeEmailRequestModel);
    $scope.updatingEmail = updatingEmail.$promise;
    updatingEmail.$promise.then(
      function() {
        ngToast.success({
          content: 'Email Updated'
        });

        authService.reLogin($scope.changeEmailRequestModel.email, $scope.changeEmailRequestModel.password);

        userinfo.setUserDetails({
          email: $scope.user.userName
        });
        $scope.changeEmailErrorState = null;
      },
      function(response) {
        $scope.changeEmailErrorState = response.data;
      }
    );
  };

  $scope.setPassword = function() {
    var settingPassword = User.setPassword($scope.setPasswordRequestModel);
    $scope.settingPassword = settingPassword.$promise;
    settingPassword.$promise.then(
      function() {
        ngToast.success({
          content: 'Password Set'
        });
        $scope.passwordErrorState = null;
        $scope.user.hasPassword = true;
        $scope.setPasswordErrorState = null;

        userinfo.setUserDetails({
          hasPassword: true
        });
      },
      function(response) {
        $scope.setPasswordErrorState = response.data;
      }
    );
  };

  $scope.changePassword = function() {
    var updatingPassword = User.changePassword($scope.updatePasswordRequestModel);
    $scope.updatingPassword = updatingPassword.$promise;
    updatingPassword.$promise.then(
      function() {
        ngToast.success({
          content: 'Password Updated'
        });
        $scope.changePasswordErrorState = null;
      },
      function(response) {
        $scope.changePasswordErrorState = response.data;

        if (response.data.errors) {
          $scope.changePasswordErrorState = response.data.errors;
        }
      }
    );
  };
}]);
